/*
 * @Description: 
 * @Version: 2.0
 * @Autor: chenkang
 * @Date: 2021-09-01 17:46:54
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2025-08-11 10:02:44
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http_pad';
import { type } from './interface';
import qs from 'qs';
export namespace TbStocktaking {
    /**
     * 添加全库盘点
     */
    export var AddTbStocktaking = (body: any): Promise<any> => {
        return Post(`/api/TbStocktaking/AddTbStocktaking`, body);
    };
    /**
     * 获取全库盘点列表
     */
    export var GetTbStocktakingList = (body: any): Promise<any> => {
        return Get(`/api/TbStocktaking/GetTbStocktakingList`, body);
    };
    /**
     * 获取盘点商品列表
     */
    export var GetTbStocktakingDetailList = (body: any): Promise<any> => {
        return Get(`/api/TbStocktaking/GetTbStocktakingDetailList`, body);
    };
    /**
     * 获取全库盘点统计
     */
    export var GetGoodsItemsTotal = (): Promise<any> => {
        return Get(`/api/TbStocktaking/GetGoodsItemsTotal`, {});
    };
    /**
     * 获取未盘点列表(盘点前)
     */
    export var GetNotStocktakingGoodItemList = (body: any): Promise<any> => {
        return Get(`/api/TbStocktaking/GetNotStocktakingGoodItemList`, body);
    };
    export var GetNotStocktakingGoodItemListV2 = (body: any): Promise<any> => {
        return Post(`/api/TbStocktaking/GetNotStocktakingGoodItemListV2`, body);
    };
   
  
    
}



// WEBPACK FOOTER //
// ./src/http/api_TbStocktaking.ts